import { PageShell } from '~/components/layout';
import { CtaBanner } from '~/components/sections';
import { AboutHero } from '~/components/sections/AboutHero';
import { AboutIntro } from '~/components/sections/AboutIntro';
import { AboutCareersCta, AboutMeetTeam } from '~/components/sections/AboutMeetTeam';

export function AboutPage() {
  return (
    <PageShell>
      <AboutHero />
      <AboutIntro />
      <AboutMeetTeam />
      <AboutCareersCta />
      <CtaBanner />
    </PageShell>
  );
}
